import {
  Button,
  SelectWrapper,
  Textfield,
  UploadButton,
} from 'components/FormsUI';
import { LinearProgress } from 'components/LinearProgress';
import { FormMessage } from 'components/Message';
import { CustomSwitch } from 'components/Switch';
import { Form, useFormikContext } from 'formik';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import ClearIcon from '@mui/icons-material/Clear';
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';

interface IAdvertisementSignUpForm {
  loading: boolean;
  success: string;
  error: string;
  update?: boolean;
  partners: any;
  bannerName?: string;
  bannerUrl?: string;
  active?: boolean;
}

export type IValues = {
  image: string;
  partner: string;
  title: string;
  url: string;
};

export const AdvertisementSignUpForm: FC<IAdvertisementSignUpForm> = ({
  loading,
  success,
  error,
  update,
  partners,
  bannerName,
  bannerUrl,
  active,
}) => {
  const history = useHistory();
  const handleGoBack = () => history.goBack();

  const { setFieldValue, values } = useFormikContext();

  const valuePartner = values as IValues;

  const handleClearClick = () => {
    setFieldValue('partner', '');
  };

  return (
    <Form encType="multipart/form-data">
      <Paper variant="outlined" sx={{ border: '2px solid #FBB45F' }}>
        {loading && <LinearProgress />}
        <Box p={2}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item container spacing={2}>
              <Grid item container direction="row">
                <Grid
                  justifyContent="flex-start"
                  alignItems="center"
                  item
                  lg={4}
                >
                  <Typography
                    variant="button"
                    color="inherit"
                    noWrap
                    sx={{ fontSize: 20, fontWeight: 500 }}
                  >
                    DADOS CADASTRAIS
                  </Typography>
                </Grid>
                {update && (
                  <Grid item lg={8} justifyContent="flex-end" display="flex">
                    <CustomSwitch
                      name="active"
                      label={active ? 'Anúncio ativado' : 'Anúncio desativado'}
                      checked={active}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <Textfield
                  required
                  name="title"
                  id="title"
                  label="TÍTULO DO ANÚNCIO"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <SelectWrapper
                  name="partner"
                  id="partner"
                  label="PARCEIRO"
                  options={partners}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        type="button"
                        onClick={handleClearClick}
                        sx={{
                          visibility:
                            valuePartner?.partner?.length > 1
                              ? 'visible'
                              : 'hidden',
                          mr: 2,
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Textfield required name="url" id="url" label="LINK" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="button"
                  sx={{ fontSize: 20, fontWeight: 500 }}
                >
                  ANEXAR IMAGEM
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <UploadButton
                  id="image"
                  name="image"
                  title={bannerName || 'ANEXAR IMAGEM'}
                  url={bannerUrl}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  O tamanho do arquivo deve conter 1M, tendo as dimensões de
                  90px por 120px.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {error && (
          <Box p={1}>
            <Grid container justifyContent="flex-end">
              <Grid item xs={6}>
                <FormMessage data={error} severity="error" />
              </Grid>
            </Grid>
          </Box>
        )}
        {success && (
          <Box p={1}>
            <Grid container justifyContent="flex-end">
              <Grid item xs={6}>
                <FormMessage data={success} severity="success" />
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>
      <Box py={1}>
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button onClick={handleGoBack}>voltar</Button>
          </Grid>
          <Grid item>
            <Button disabled={loading}>
              {update ? 'ATUALIZAR' : 'CADASTRAR'}
              {loading && (
                <CircularProgress
                  size="small"
                  sx={{ width: 24, height: 24, ml: 2 }}
                />
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Form>
  );
};

